import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMOJI = { like: "👍", love: "❤️", haha: "😂", wow: "😮", sad: "😢", angry: "😡", care: "🤗" };

export default function LikersDialog({ postId, open, onOpenChange }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !postId) return;
    setLoading(true);
    axios.get(`${API}/posts/${postId}/likers`)
      .then((r) => setUsers(r.data?.users || []))
      .catch(() => setUsers([]))
      .finally(() => setLoading(false));
  }, [open, postId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid={`likers-dialog-${postId}`}>
        <DialogHeader>
          <DialogTitle>Quem curtiu</DialogTitle>
          <DialogDescription>Toque em alguém para abrir o perfil.</DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto space-y-1 -mx-2">
          {loading && <div className="flex justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>}
          {!loading && users.length === 0 && (
            <div className="text-sm text-muted-foreground text-center py-6" data-testid="likers-empty">Ninguém curtiu ainda.</div>
          )}
          {users.map((u) => (
            <Link
              key={u.user_id}
              to={`/user/${u.user_id}`}
              onClick={() => onOpenChange(false)}
              data-testid={`liker-${u.user_id}`}
              className="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-accent transition-colors"
            >
              <Avatar className="w-9 h-9">
                <AvatarImage src={u.picture} />
                <AvatarFallback>{u.name?.[0]}</AvatarFallback>
              </Avatar>
              <span className="flex-1 text-sm font-medium truncate hover:underline">{u.name}</span>
              <span className="text-lg leading-none">{EMOJI[u.emoji] || "👍"}</span>
            </Link>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
